import React, { useEffect, useState } from 'react'
import { Container, Col, Row } from 'react-bootstrap'
import { RiFacebookFill, RiYoutubeFill, RiTwitterFill, RiInstagramFill, RiLinkedinFill, RiRefund2Fill, RiRobotFill, RiBarChartHorizontalLine, RiWhatsappFill } from "react-icons/ri";
import { Link, useLocation } from 'react-router-dom';
import { SiInstagram } from "react-icons/si";
import { Menu, Dropdown, Drawer, Modal, Select, Button, Spin, message } from 'antd';
import { DownOutlined } from '@ant-design/icons';
// Select Language
import { withTranslation } from 'react-i18next';
import LanguageSelect from "../../../LanguageSelect";
import Logo from "../../../asstes/images/header_logo.png"
import InstagramWithBg from "../../../asstes/images/with-bg-logo.png"
import InstagramWithoutBg from "../../../asstes/images/without_bg.png"
import XIcon from '@mui/icons-material/X';

function DefaultHeaderComponents() {

    const location = useLocation();
    // Function to check if the current route matches the menu item's path
    const isActive = (path) => location.pathname === path;
    const selectedCurrency = localStorage.getItem("currency") || "BDT";
    const selectedUnit = localStorage.getItem("unit") || "sqft";
    const [visible, setVisible] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currency, setIsCurrency] = useState(selectedCurrency);
    const [unit, setIsUnit] = useState(selectedUnit);
    const { SubMenu } = Menu;

    const showDrawer = () => {
        setVisible(true);
    };
    const onClose = () => {
        setVisible(false);
    };
    // siteSettings
    const showModal = (type) => {
        setIsModalOpen(type);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const changeCurrency = (e) => {
        setIsCurrency(e);
    };
    const saveCurrency = () => {
        localStorage.setItem("currency", currency);
        setIsModalOpen(false);
        message.success('Currency ' + currency + ' Selected Successfully');
    };
    const changeUnit = (e) => {
        setIsUnit(e);
    };
    const saveUnit = () => {
        localStorage.setItem("unit", unit);
        setIsModalOpen(false);
        message.success('Area Unit ' + unit + ' Selected Successfully');
    };
    const siteSettings = (
        <>
            <Menu>
                <Menu.Item key={1} onClick={() => showModal("currency")} className="site-setting-option"><RiRefund2Fill />Change Currency</Menu.Item>
                <Menu.Item key={2} onClick={() => showModal("unit")} className="site-setting-option"><RiRobotFill />Change Area Unit</Menu.Item>
            </Menu>
            {isModalOpen === "currency" ? <>
                <Modal title="Change Currency" footer={null} width={350} open={isModalOpen} onCancel={handleCancel}>
                    <Select
                        defaultValue="Select Currency"
                        className="w-100 mb-3"
                        value={currency}
                        onChange={changeCurrency}
                        options={[
                            { value: 'AED', label: 'United Arab Emirates (AED)' },
                            { value: 'BDT', label: 'Bangladesh (BDT)' },
                            { value: 'XPF', label: 'New Caledonia (XPF)' },
                            { value: 'ANG', label: 'Netherlands Antilles (ANG)' },
                            { value: 'EUR', label: 'European Union (EUR)' },
                            { value: 'NPR', label: 'Nepal (NPR)' },
                            { value: 'USD', label: 'United States of America (USD)' },
                        ]}
                    />
                    <Button className='button__call_' onClick={handleCancel} style={{ float: "left" }}>
                        Cancel
                    </Button>
                    <Button className='button__call_' onClick={saveCurrency} style={{ float: "right" }}>
                        Save
                    </Button>
                </Modal>
            </> : null}
            {isModalOpen === "unit" ? <>
                <Modal title="Change Area Unit" footer={null} width={350} open={isModalOpen} onCancel={handleCancel}>
                    <Select
                        defaultValue="Select Area Unit"
                        className="w-100 mb-3"
                        value={unit}
                        onChange={changeUnit}
                        options={[
                            { value: 'sqft', label: 'Square Feet' },
                            { value: 'Sq. Yd.', label: 'Square Yards' },
                            { value: 'Sq. M.', label: 'Square Meters' },
                            { value: 'Katha', label: 'Katha' },
                        ]}
                    />
                    <Button className='button__call_' onClick={handleCancel} style={{ float: "left" }}>
                        Cancel
                    </Button>
                    <Button className='button__call_' onClick={saveUnit} style={{ float: "right" }}>
                        Save
                    </Button>
                </Modal>
            </> : null}
        </>
    );
    // Buy
    const buy = (
        <Menu>
            <Menu.Item> Bangladesh </Menu.Item>
            <Menu.Item> <Link to="/apartments-for-sale"> Apartments for Sale  </Link> </Menu.Item>
            <Menu.Item> <Link to="/apartments-for-sale"> Buildings for Sale </Link> </Menu.Item>
            <Menu.Item> <Link to="/apartments-for-sale"> Duplex for Sale  </Link> </Menu.Item>
            <Menu.Item> <Link to="/apartments-for-sale"> All Residential Properties  </Link> </Menu.Item>
            <Menu.Item> <Link to="/apartments-for-sale"> All Commercial Properties  </Link> </Menu.Item>
        </Menu>
    )
    // Rent
    const rent = (
        <Menu>
            <Menu.Item> Bangladesh </Menu.Item>
            <Menu.Item> <Link to="/apartments-for-sale"> Apartments for Rent  </Link> </Menu.Item>
            <Menu.Item> <Link to="/apartments-for-sale"> Buildings for Rent </Link> </Menu.Item>
            <Menu.Item> <Link to="/apartments-for-sale"> Duplex for Rent  </Link> </Menu.Item>
            <Menu.Item> <Link to="/apartments-for-sale"> All Residential Properties  </Link> </Menu.Item>
            <Menu.Item> <Link to="/apartments-for-sale"> All Commercial Properties  </Link> </Menu.Item>
        </Menu>
    )
    // Projects
    const projects = (
        <Menu>
            <Menu.Item>
                <Link className={isActive('/new-projects') ? 'active' : ''} to="/new-projects?type=1"> Upcoming </Link>
            </Menu.Item>
            <Menu.Item>
                <Link className={isActive('/on-going-projects') ? 'active' : ''} to="/on-going-projects?type=2"> On Going  </Link>
            </Menu.Item>
            <Menu.Item>
                <Link className={isActive('/completed-projects') ? 'active' : ''} to="/completed-projects?type=3"> Completed </Link>
            </Menu.Item>
        </Menu>
    )
    // Guides
    const guides = (
        <Menu>
            <Menu.Item>
                <Link className={isActive('/area-guides') ? 'active' : ''} to="/area-guides"> Area Guides  </Link>
            </Menu.Item>
            <Menu.Item>
                <Link className={isActive('/real-estate-solutions') ? 'active' : ''} to="/real-estate-solutions"> Buy/Sell Guide </Link>

            </Menu.Item>
            <Menu.Item>
                <Link className={isActive('/loan-calculator') ? 'active' : ''} to="/loan-calculator"> Loan Calculator </Link>
            </Menu.Item>
        </Menu>
    )
    // Services
    const services = (
        <Menu>
            <Menu.Item>
                <Link className={isActive('/home-loan') ? 'active' : ''} to="/home-loan"> Home Loan  </Link>
            </Menu.Item>
            <Menu.Item>
                <Link className={isActive('/interior') ? 'active' : ''} to="/interior"> Interior </Link>
            </Menu.Item>
        </Menu>
    )

    const [background, setBackground] = useState('rgba(0, 0, 0, 0.54)');
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setBackground('rgba(0, 0, 0, 0.90)'); // Darker background on scroll
            } else {
                setBackground('rgba(0, 0, 0, 0.54)'); // Lighter background at the top
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const topHeaderStyle = {
        position: 'fixed',
        top: 0,
        width: '100%',
        height: '47px',
        zIndex: 10000,
        background: '#FFFFFF',
        paddingTop: '6px'
    }

    return (
        <div>
            <div style={topHeaderStyle} className='top-header'>
                <Container>
                    <Row>
                        <Col xs={4} lg={6}>
                            <div className='languageSelect_Area'>
                                <LanguageSelect />
                            </div>
                            {/* <div className='header_to_setting header_to_setting_txt '>
                                <Dropdown overlay={siteSettings}>
                                    <Link className="ant-dropdown-link" to="/" onClick={e => e.preventDefault()}>
                                        <RiSettings5Fill />
                                        Site Settings
                                    </Link>
                                </Dropdown>
                            </div> */}
                        </Col>
                        <Col xs={8} lg={6}>
                            <div className='header_tot_r'>
                                <div className='icon__header fb-icon' >
                                    <Link to="https://www.facebook.com/propertyindexbdt" target='_blank'>
                                        <RiFacebookFill />
                                    </Link>
                                </div>
                                <div className='icon__header yt-icon' >
                                    <Link to="https://www.youtube.com/@PropertyIndexPropertyTour" target='_blank'>
                                        <RiYoutubeFill />
                                    </Link>
                                </div>
                                <div className='icon__header ins-icon'>
                                    <Link to="https://www.instagram.com/propertyindexbdt?igsh=Y2NhaGNuazh1Z2Rw" target='_blank'>
                                        <img src={InstagramWithBg} alt="instagram" id='insta1' />
                                        <img src={InstagramWithoutBg} alt="instagram" id='insta2' />
                                    </Link>
                                </div>
                                <div className='icon__header ln-icon' >
                                    <Link to="https://www.linkedin.com/company/property-index-ltd" target='_blank'>
                                        <RiLinkedinFill />
                                    </Link>
                                </div>
                                <div className='icon__header tw-icon' >
                                    <Link to="https://x.com/propertyindexbd" target='_blank'>
                                        <XIcon />
                                    </Link>
                                </div>
                                <div className='icon__header wa-icon' >
                                    <Link to="https://wa.me/+8801619913922" target='_blank'>
                                        <RiWhatsappFill />
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className='header_logo_menu_area' style={{ background }}>
                <Container>
                    <Row>
                        <Col sm={3} lg={3}>
                            <div className='logo_area'>
                                <Link to="/"> <img src={Logo} alt="logo" /> </Link>
                                <RiBarChartHorizontalLine onClick={showDrawer} className='rasponsive_menu' />
                            </div>
                        </Col>
                        <Col sm={9} lg={9}>
                            <div className='menu_area'>
                                <Link className={isActive('/') ? 'active' : ''} to="/"> Home </Link>
                                <Link className={isActive('/about-us') ? 'active' : ''} to="/about-us"> About us </Link>
                                <Link className={isActive('/add-property') ? 'active' : ''} to="/add-property"> Add Property </Link>
                                <Dropdown overlay={projects}>
                                    <Link className={`ant-dropdown-link ${isActive('/new-projects') || isActive('/on-going-projects') || isActive('/completed-projects') ? 'active' : ''}`} to="/" onClick={e => e.preventDefault()}>
                                        Projects <DownOutlined />
                                    </Link>
                                </Dropdown>
                                <Link className={isActive('/blog') ? 'active' : ''} to="/blog"> Blog </Link>
                                <Dropdown overlay={guides}>
                                    <Link className={`ant-dropdown-link ${isActive('/area-guides') || isActive('/real-estate-solutions') || isActive('/loan-calculator') ? 'active' : ''}`} to="/" onClick={e => e.preventDefault()}>
                                        Guides <DownOutlined />
                                    </Link>
                                </Dropdown>
                                <Dropdown overlay={services}>
                                    <Link className={`ant-dropdown-link ${isActive('/home-loan') || isActive('/interior') ? 'active' : ''}`} to="/" onClick={e => e.preventDefault()}>
                                        {/* <span className="menu__offer"> new </span> */}
                                        Services <DownOutlined />
                                    </Link>
                                </Dropdown>
                                <Link className={isActive('/career') ? 'active' : ''} to="/career"> Career </Link>
                                <Link className={isActive('/contact-us') ? 'active' : ''} to="/contact-us"> Contact us </Link>

                                {/*<Link to="/"> <span className="menu__offer"> new </span> Trends </Link>*/}
                            </div>
                        </Col>
                    </Row>
                    <Drawer title="&nbsp;" placement="right" width="auto" onClose={onClose} visible={visible}>
                        <div className='d-flex flex-column'>
                            <Link className='mb-2' to="/"> Home </Link>
                            <Link className='mb-2' to="/about-us"> About us </Link>
                            <Link className='mb-2' to="/add-property"> Add Property </Link>
                            <Dropdown className='mb-2' overlay={projects}>
                                <Link className="ant-dropdown-link" to="/" onClick={e => e.preventDefault()}>
                                    Projects <DownOutlined />
                                </Link>
                            </Dropdown>
                            <Link className='mb-2' to="/blog"> Blog </Link>
                            <Dropdown className='mb-2' overlay={guides}>
                                <Link className="ant-dropdown-link" to="/" onClick={e => e.preventDefault()}>
                                    Guides <DownOutlined />
                                </Link>
                            </Dropdown>
                            <Dropdown overlay={services}>
                                <Link className="ant-dropdown-link" to="/" onClick={e => e.preventDefault()}>
                                    {/* <span className="menu__offer"> new </span> */}
                                    Services <DownOutlined />
                                </Link>
                            </Dropdown>
                            <Link className='mb-2' to="/career"> Career </Link>
                            <Link className='mb-2' to="/contact-us"> Contact us </Link>
                        </div>
                    </Drawer>
                </Container>
            </div>
        </div>
    )
}

export default withTranslation()(DefaultHeaderComponents)
